
import Vue from 'vue'

export default Vue.extend({
  name: 'FinishedSVG',
  props: {
    color: {
      type: String,
      required: true
    }
  }
})
